import { Component, OnInit } from '@angular/core';
import { environment } from "@env/environment";

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {
  public appVersion = environment.appVersion;
  public templateVersion = environment.templateVersion;
  public versionStr = "Versión Sistema " + this.appVersion + "\nVersión Template " + this.templateVersion;
  
  constructor() { }

  ngOnInit() {
  }

}
